import React from 'react';
import { ArrowLeft } from 'lucide-react';

const ConstructionCapy = () => (
  <svg viewBox="0 0 400 400" className="w-64 h-64 drop-shadow-2xl">
    <defs>
      <linearGradient id="capyGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#E79152" />
        <stop offset="100%" stopColor="#D97706" />
      </linearGradient>
    </defs>
    
    {/* Body */}
    <rect x="80" y="120" width="240" height="240" rx="90" fill="url(#capyGradient)" />
    <rect x="120" y="240" width="160" height="100" rx="45" fill="rgba(255,255,255,0.2)" />
    
    {/* Eyes */}
    <circle cx="160" cy="200" r="12" fill="#0F172A" />
    <circle cx="240" cy="200" r="12" fill="#0F172A" />
    
    {/* Nose/Mouth */}
    <path d="M190 260 Q200 270 210 260" fill="none" stroke="#0F172A" strokeWidth="7" strokeLinecap="round" />
    <path d="M170 280 Q200 310 230 280" fill="none" stroke="#0F172A" strokeWidth="6" strokeLinecap="round" />

    {/* Hard Hat */}
    <path d="M 70 140 Q 200 60 330 140" fill="#FACC15" stroke="#CA8A04" strokeWidth="4" />
    <rect x="70" y="140" width="260" height="20" rx="5" fill="#FACC15" stroke="#CA8A04" strokeWidth="4" />
    <rect x="180" y="100" width="40" height="40" rx="4" fill="#FEF08A" opacity="0.5" />
    
    {/* Hammer/Tool */}
    <g transform="translate(280, 200) rotate(15)">
       <rect x="0" y="0" width="20" height="80" fill="#475569" rx="4" />
       <rect x="-20" y="-10" width="60" height="30" fill="#94A3B8" rx="4" />
    </g>
  </svg>
);

const ComingSoon = () => {
  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-950 flex flex-col items-center justify-center p-6 text-center">
      <div className="mb-8 animate-bounce-slow">
        <ConstructionCapy />
      </div>
      
      <h1 className="text-4xl md:text-5xl font-extrabold text-slate-900 dark:text-white mb-4 tracking-tight">
        We are on it!
      </h1>
      
      <p className="text-lg text-slate-600 dark:text-slate-400 max-w-md mb-10">
        Our Capybaras are working hard to build this page. Check back soon for updates.
      </p>
      
      <a 
        href="/"
        className="inline-flex items-center gap-2 px-6 py-3 bg-teal-600 hover:bg-teal-700 text-white rounded-xl font-bold transition-all hover:scale-105"
      >
        <ArrowLeft size={20} />
        Back to Home
      </a>
    </div>
  );
};

export default ComingSoon;